import dayjs from "dayjs";
import { MILLISECONDS_PER_DAY } from "../constants";

export const isPlannedClosingDateLessThanThirteenDaysAway = (
  plannedClosingDate
) => {
  if (!plannedClosingDate) return false;

  let formattedDate = plannedClosingDate;

  if (plannedClosingDate instanceof Date) {
    formattedDate = dayjs(plannedClosingDate).format("MM/DD/YYYY");
  }

  const [closingMonth, closingDay, closingYear] = formattedDate
    .split("/")
    .map(Number);

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set the time to midnight

  const closingDate = new Date(closingYear, closingMonth - 1, closingDay);
  closingDate.setHours(0, 0, 0, 0); // Set the time to midnight

  const millisecondsDiff = closingDate.getTime() - today.getTime();
  const daysDiff = Math.round(millisecondsDiff / MILLISECONDS_PER_DAY);

  return daysDiff < 13; //only reject if user somehow got a very short dayDiff
};
